import { Box, Grid, GridColumn, Link } from "@modernatx-internal/ui-kit-react";
import React from "react";

import { useCorporateSiteLocalePath } from "@/hooks/useCorporateSiteLocalePath";
import { useExperience } from "@/hooks/useExperience";
import { useText } from "@/hooks/useText";

export const PageFooter: React.FC = () => {
  const { documentIds } = useExperience();
  const localePath = useCorporateSiteLocalePath();
  const { getText } = useText();
  const currentYear = React.useMemo(() => new Date().getFullYear(), []);
  const appVersion = process.env.version;

  return (
    <Grid variant="uniform-12">
      <GridColumn
        sx={{
          display: "none",
          fontSize: "font-size-3",
          // @ts-ignore
          "@media print": {
            display: "block",
            mt: 4
          }
        }}
      >
        {getText("VERSION")} {appVersion} {documentIds.join(" ")}
      </GridColumn>
      <GridColumn
        sx={{
          color: "text-secondary",
          display: "flex",
          flexDirection: ["column", null, "row"],
          fontSize: "font-size-3",
          gap: [2, null, 0],
          py: [4, null, 8],
          // @ts-ignore
          "@media print": {
            display: "none"
          }
        }}
      >
        <Box sx={{ display: "flex", gap: 6 }}>
          <Link
            href={`https://modernatx.com${localePath}/privacy-statement`}
            sx={{ color: "currentColor" }}
            target="_blank"
          >
            {getText("PRIVACY_POLICY")}
          </Link>
          <Box sx={{ color: "stroke-neutral-tertiary" }}>|</Box>
          <Link
            href={`https://modernatx.com${localePath}/terms-of-use`}
            sx={{ color: "currentColor" }}
            target="_blank"
          >
            {getText("TERMS_AND_CONDITIONS")}
          </Link>
        </Box>
        <Box sx={{ display: "flex", gap: 6, marginInlineStart: [0, null, "auto"] }}>
          {getText("VERSION")} {appVersion}
          {documentIds.length ? " " : ""}
          {documentIds.join(" ")}
          <Box sx={{ color: "stroke-neutral-tertiary" }}>|</Box>© {currentYear}{" "}
          {getText("MODERNA_INC")}
        </Box>
      </GridColumn>
    </Grid>
  );
};
